import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { typeMessages, codeMessages, declinesMessages } from './messages'

const getErrorMessage = (error) =>
    declinesMessages[error.decline_code] ||
    codeMessages[error.code] ||
    typeMessages[error.type]

const StripeErrorMessage = ({ stripeError }) => {
    const message = getErrorMessage(stripeError)

    if (!message) {
        return (
            <span>{stripeError.message}</span>
        )
    }

    return (
        <FormattedMessage {...getErrorMessage(stripeError)} />
    )
}

StripeErrorMessage.propTypes = {
    stripeError: PropTypes.shape({
        type: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        code: PropTypes.string,
        decline_code: PropTypes.string,
    }).isRequired,
}

export default StripeErrorMessage
